<template>
    <!--검사 상태-->
    <div class="box-container">

        <div class="box-container-header">
            <h3 class="box-title">
                {{ $t('LABEL.EVAL_SCORE')}}<!--검사 점수-->
                <button type="button" class="buttons-icon" data-type="ghost" data-size="xs" data-icon="info" data-trigger="tooltip"
                        v-bind:title="$t('COMPLIANCE.RESULT.TOOLTIP_SCORE_CHART')">info</button>
            </h3>

            <div class="actions">
                <strong class="compliance-point">{{cData.score}}%</strong>
            </div>
        </div>


        <div class="chart chart-legend-html" style="height: 280px; padding:0 25px;">
            <div id="cmpl-score-chartdiv" class="compliance-score-chartdiv" style="width: 40%; height: 100%; padding: 10px 0px 0px 0px; position: relative;">
            </div>
            <div class="legend-list-wrapper compliance-list-wrapper">
                <ul class="legend-list">
                    <li :class="{'open' : activeFail === 'P'}">
                        <button>
                            <p>
                                <span class="chart-chip" style="background:#1EA4FF;"></span>
                                <span class="text">{{$t('COMPLIANCE.EVAL_STAT.PASSED')}}</span>
                            </p>
                            <p>{{cData.pass.length}}<em>/{{cData.totCnt}}</em></p>
                        </button>
                        <ul>
                            <li v-for="index in 4">
                                <p>
                                    <span class="urgency" :data-severity="5-index">
                                        <em></em>
                                        <em></em>
                                        <em></em>
                                        <em></em>
                                    </span>
                                    <span>{{$t('LABEL.SVRTY.'+(5-index))}}</span>
                                </p>
                                <p>
                                    <span>{{getSeverityData('P',5-index)}}</span>/<em>{{cData.pass.length}}</em>
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li :class="{'open' : activeFail === 'F'}">
                        <button>
                            <p>
                                <span class="chart-chip" style="background:#FF2D47;"></span>
                                <span class="text">{{$t('COMPLIANCE.EVAL_STAT.FAILED')}}</span>
                            </p>
                            <p>{{cData.fail.length}}<em>/{{cData.totCnt}}</em></p>
                        </button>
                        <ul>
                            <li v-for="index in 4">
                                <p>
                                    <span class="urgency" :data-severity="5-index">
                                        <em></em>
                                        <em></em>
                                        <em></em>
                                        <em></em>
                                    </span>
                                    <span>{{$t('LABEL.SVRTY.'+(5-index))}}</span>
                                </p>
                                <p>
                                    <span>{{getSeverityData('F',5-index)}}</span>/<em>{{cData.fail.length}}</em>
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li :class="{'open' : activeFail === 'E'}">
                        <button>
                            <p>
                                <span class="chart-chip" style="background:#82353E;"></span>
                                <span class="text">{{$t('COMPLIANCE.EVAL_STAT.ERROR')}}</span>
                            </p>
                            <p>{{cData.error.length}}<em>/{{cData.totCnt}}</em></p>
                        </button>
                        <ul>
                            <li v-for="index in 4">
                                <p>
                                    <span class="urgency" :data-severity="5-index">
                                        <em></em>
                                        <em></em>
                                        <em></em>
                                        <em></em>
                                    </span>
                                    <span>{{$t('LABEL.SVRTY.'+(5-index))}}</span>
                                </p>
                                <p>
                                    <span>{{getSeverityData('E',5-index)}}</span>/<em>{{cData.error.length}}</em>
                                </p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>


<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import _ from "lodash";
    import {mapGetters} from "vuex";

    export default {
        name: 'TabResultScore',
        props: {
            cData: Object,
            activeFail: String,
            locale: String,
        },
        data: function() {
            return {
                  chartData: [
                    {
                        category: "One",
                        value1: 0,
                        value2: 0,
                        value3: 0,
                    }
                ]
            }
        },
        mounted() {
            this.setData3();
            this.initActionTooltip();
        },
        watch: {
            locale() {
                this.setData3()
            }
        },
        methods: {
            getSeverityData: function (evalStat, svrty) {
                let count = 0;
                if(evalStat === 'P'){
                    count = _.filter(this.cData.pass, {'svrty': svrty} ).length
                }else if(evalStat === 'F'){
                    count = _.filter(this.cData.fail, {'svrty': svrty} ).length
                }else{
                    count = _.filter(this.cData.error, {'svrty': svrty} ).length
                }
                return count;
            },
            setData3: function(){
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                //auto add Class for customizing
                am4core.options.autoSetClassName = true;

                var cpChart = am4core.create("cmpl-score-chartdiv", am4charts.XYChart);
                cpChart.hiddenState.properties.opacity = 0; // this creates initial fade-in

                cpChart.data = [
                    {
                        category: "",
                        value1: this.cData.pass.length ,
                        value2: this.cData.fail.length ,
                        value3: this.cData.error.length
                    }
                ];

                /*color set*/
                let colorList = [];

                if(this.cData.error.length > 0){
                    colorList.push("#CB1D32")
                }
                if(this.cData.fail.length > 0){
                    colorList.push("#FF2D47")
                }
                if(this.cData.pass.length > 0){
                    colorList.push("#1EA4FF")
                }
                var colorSet = new am4core.ColorSet();
                colorSet.list = colorList.map(function (color) {
                    return new am4core.color(color);
                });

                cpChart.colors = colorSet;
                cpChart.padding(10, 20, 0, 0);
                //cpChart.contentWidth = am4core.percent(20);
                // cpChart.contentWidth

                cpChart.legend = new am4charts.Legend();
                cpChart.legend.position = "right";
                cpChart.legend.fontSize = 12;
                //cpChart.legend.width = am4core.percent(360);
                cpChart.legend.maxWidth = 373;
                cpChart.legend.itemContainers.template.togglable = false;

                cpChart.legend.disabled = true;

                // compliance toggle
                var $complianceWrapper = document.querySelectorAll('.compliance-list-wrapper')[0];
                var $complianceLegend =  $complianceWrapper.querySelectorAll('.legend-list')[0];


                var compliancelegendListLi = $complianceLegend.children;
                var $compliancelegendListLi = Array.prototype.slice.call(compliancelegendListLi);


                function siblings(t){
                    var children = t.parentElement.children;
                    var tempArr = [];

                    for(var i = 0; i < children.length; i++){
                        tempArr.push(children[i]);
                    }

                    return tempArr.filter(function(e){
                        return e != t;
                    })
                }

                $compliancelegendListLi.forEach(function(el,idx,all){
                    el.addEventListener('click',function(){

                        var sib = siblings(el);

                        sib.forEach(function(el){
                            el.classList.remove('open')
                        })

                        this.classList.toggle('open')
                    })
                })

                /*label marker styling*/
                cpChart.legend.useDefaultMarker = true;
                var marker = cpChart.legend.markers.template.children.getIndex(0);
                marker.cornerRadius(0, 0, 0, 0);
                var markerTemplate = cpChart.legend.markers.template;
                markerTemplate.width = 12;
                markerTemplate.height = 12;

                var categoryAxis = cpChart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "category";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.grid.template.opacity = 0;

                var valueAxis = cpChart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.max = 100;
                valueAxis.fontSize = 12;
                valueAxis.strictMinMax = true;
                valueAxis.calculateTotals = true;
                valueAxis.renderer.minWidth = 0;
                valueAxis.renderer.grid.template.opacity = 0;
                valueAxis.renderer.ticks.template.strokeOpacity = 0;
                valueAxis.renderer.ticks.template.stroke = am4core.color("#ff0000");
                valueAxis.renderer.ticks.template.length = 0;
                valueAxis.renderer.line.strokeOpacity = 0;
                valueAxis.renderer.baseGrid.disabled = true;
                valueAxis.renderer.minGridDistance = 40;

                if(this.cData.error.length > 0) {
                    // 에러
                    var errorSeries = cpChart.series.push(new am4charts.ColumnSeries());
                    errorSeries.columns.template.tooltipText =
                        "{name}: {valueY.totalPercent.formatNumber('#.00')}%";
                    errorSeries.name = this.$t('COMPLIANCE.RESULT.ERROR_SCORE');
                    errorSeries.dataFields.categoryX = "category";
                    errorSeries.dataFields.valueY = "value3";
                    errorSeries.dataFields.valueYShow = "totalPercent";
                    errorSeries.dataItems.template.locations.categoryX = 0.5;
                    errorSeries.stacked = true;
                    errorSeries.tooltip.pointerOrientation = "vertical";

                    errorSeries.columns.template.tooltipHTML=`<div class="common-tooltip" style="min-width:150px;">
						  <table>
						    <tr>
						      <th align="left">{name}</th>
						      <td>
						        `+this.round(this.cData.error.length/this.cData.totCnt*100) +`% | `+this.cData.error.length+`
						      </td>
						    </tr>
						  </table>
						</div>`

                    errorSeries.tooltip.pointerOrientation = "bottom";
                    errorSeries.tooltip.background.fill = am4core.color("#FFF");
                    errorSeries.tooltip.background.fillOpacity = 1;
                    errorSeries.tooltip.background.cornerRadius = 0;
                    errorSeries.tooltip.getFillFromObject = false;
                    errorSeries.tooltip.fillOpacity = 1;
                    errorSeries.tooltip.getStrokeFromObject = true;
                    errorSeries.tooltip.background.strokeWidth = 0;
                    errorSeries.tooltip.zIndex = 5555;

                    errorSeries.events.on('over',function(el){
                        $compliancelegendListLi.forEach(function(el,idx,all){
                            var sib = siblings(el);

                            sib.forEach(function(el){
                                el.classList.remove('open')
                            })
                        })
                        compliancelegendListLi[2].classList.add('open')
                    })
                }



                if(this.cData.fail.length > 0) {
                    var failSeries = cpChart.series.push(new am4charts.ColumnSeries());
                    failSeries.columns.template.tooltipText =
                        "{name}: {valueY.totalPercent.formatNumber('#.00')}%";
                    failSeries.name = this.$t('COMPLIANCE.RESULT.FAIL_SCORE');
                    failSeries.dataFields.categoryX = "category";
                    failSeries.dataFields.valueY = "value2";
                    failSeries.dataFields.valueYShow = "totalPercent";
                    failSeries.dataItems.template.locations.categoryX = 0.5;
                    failSeries.stacked = true;
                    failSeries.tooltip.pointerOrientation = "vertical";

                    failSeries.columns.template.tooltipHTML = `<div class="common-tooltip" style="min-width:150px;">
						  <table>
						    <tr>
						      <th align="left">{name}</th>
						      <td>
						        ` + this.round(this.cData.fail.length / this.cData.totCnt * 100) + `% | ` + this.cData.fail.length + `
						      </td>
						    </tr>
						  </table>
						</div>`

                    failSeries.tooltip.pointerOrientation = "bottom";
                    failSeries.tooltip.background.fill = am4core.color("#FFF");
                    failSeries.tooltip.background.fillOpacity = 1;
                    failSeries.tooltip.background.cornerRadius = 0;
                    failSeries.tooltip.getFillFromObject = false;
                    failSeries.tooltip.fillOpacity = 1;
                    failSeries.tooltip.getStrokeFromObject = true;
                    failSeries.tooltip.background.strokeWidth = 0;
                    failSeries.tooltip.zIndex = 5555;

                    failSeries.events.on('over', function (el) {
                        $compliancelegendListLi.forEach(function (el, idx, all) {
                            var sib = siblings(el);

                            sib.forEach(function (el) {
                                el.classList.remove('open')
                            })
                        })
                        compliancelegendListLi[1].classList.add('open')
                    })
                }

                if(this.cData.pass.length > 0){
                    var passSeries = cpChart.series.push(new am4charts.ColumnSeries());
                    passSeries.columns.template.tooltipText =
                        "{name}: {valueY.totalPercent.formatNumber('#.00')}%";
                    passSeries.name = this.$t('COMPLIANCE.RESULT.PASS_SCORE');
                    passSeries.dataFields.categoryX = "category";
                    passSeries.dataFields.valueY = "value1";
                    passSeries.dataFields.valueYShow = "totalPercent";
                    passSeries.dataItems.template.locations.categoryX = 0.5;
                    passSeries.stacked = true;
                    passSeries.tooltip.pointerOrientation = "vertical";
                    passSeries.marginLeft = 30;

                    passSeries.columns.template.tooltipHTML=`<div class="common-tooltip" style="min-width:150px;">
						  <table>
						    <tr>
						      <th align="left">{name}</th>
						      <td>
						        `+this.round(this.cData.pass.length/this.cData.totCnt*100) +`% | `+this.cData.pass.length+`
						      </td>
						    </tr>
						  </table>
						</div>`

                    passSeries.tooltip.pointerOrientation = "bottom";
                    passSeries.tooltip.background.fill = am4core.color("#FFF");
                    passSeries.tooltip.background.fillOpacity = 1;
                    passSeries.tooltip.background.cornerRadius = 0;
                    passSeries.tooltip.getFillFromObject = false;
                    passSeries.tooltip.fillOpacity = 1;
                    passSeries.tooltip.getStrokeFromObject = true;
                    passSeries.tooltip.background.strokeWidth = 0;
                    passSeries.tooltip.zIndex = 5555;

                    passSeries.events.on('over',function(el){
                        $compliancelegendListLi.forEach(function(el,idx,all){
                            var sib = siblings(el);

                            sib.forEach(function(el){
                                el.classList.remove('open')
                            })
                        })
                        compliancelegendListLi[0].classList.add('open')
                    })
                }

            },
            round(i){
                return this.Common.round(i,2);
            },
            initActionTooltip() {
                let target = $('[data-trigger="tooltip"]');
                target.tooltipster({
                    delay: 300,
                    animation: 'fade',
                    updateAnimation: 'fade',
                    side: 'bottom',
                    arrow: true,
                    contentAsHTML: true,
                    interactive: true,
                    functionPosition: function(instance, helper, position){
                        if (position.coord.left < 52) {
                            position.coord.left = 52;
                        }
                        return position;
                    }
                });
            },
    }
}
</script>
<style>
    @import '../../../../static/styles/gv_amchart.css';
    .amcharts-Rectangle-group{fill:red !important;}
</style>



// WEBPACK FOOTER //
// src/components/compliance/widget/TabResultScore.vue